import * as React from 'react';
import DateTimeFormatter from '../../../helpers/DateTimeFormatter';

const FlightTime = (props) => {

    let departureMonth, departureDay, departureDate, returnMonth, returnDay, returnDate;

    if (props.returnDate) {
        returnDate = new Date(props.returnDate);
        returnMonth = DateTimeFormatter.getMonthOf(returnDate.getMonth(), true);
        returnDay = returnDate.getDate();
    }

    departureDate = new Date(props.departureDate);
    departureMonth = DateTimeFormatter.getMonthOf(departureDate.getMonth(), true);
    departureDay = departureDate.getDate();

    let getPassenger = () => {
        let adults = parseInt(props.adults, 10),
            children = parseInt(props.children, 10),
            infants = parseInt(props.infants, 10);

        let adultsText, childrenText, infantsText;
        if (adults === 1) {
            adultsText = `${adults} ${props.translator['adult']}`;
        } else {
            adultsText = `${adults} ${props.translator['adults']}`;
        }
        if (!!children) {
            if (children === 1) {
                childrenText = `${children} ${props.translator['child']}`;
            } else {
                childrenText = `${children} ${props.translator['children']}`;
            }
        }
        if (!!infants) {
            if (infants === 1) {
                infantsText = `${infants} ${props.translator['infant']}`;
            } else {
                infantsText = `${infants} ${props.translator['infants']}`;
            }
        }

        return `${adultsText} ${children ? `, ${childrenText}` : ``} ${infants ? `, ${infantsText}` : ``}`;
    };

    if (props.returnDate) {
        return (
            <React.Fragment>
                <div className="mb-0 mobile-flight-time">
                    <span className="mr-2">{props.translator[departureMonth]} {departureDay} - {props.translator[returnMonth]} {returnDay}</span>
                    <span className={`mobile-passenger-info mobile-one-line`}>{getPassenger()}</span>
                    <div className={`mobile-passenger-info`}>
                        {getPassenger()}
                    </div>
                </div>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <p className="mb-0 mobile-flight-time">
                <span className="mr-2">{props.translator[departureMonth]} {departureDay}</span>
                <span className={`mobile-passenger-info mobile-one-line`}>{getPassenger()}</span>
                <div className={`mobile-passenger-info`}>
                    {getPassenger()}
                </div>
            </p>
        </React.Fragment>
    );
};

export default FlightTime;



// WEBPACK FOOTER //
// ./src/components/flights/FlightCard/FlightTime.js